// removed by extract-text-webpack-plugin
module.exports = {"sectionImg":"_1k_SzZwOhpDhnU0KEgXwud","imgPrez":"_1kR13bmBdHVVij0BWrz5lY"};


//////////////////
// WEBPACK FOOTER
// ./work/swipolitique/styles.module.css
// module id = 755
// module chunks = 0